import { Navigate, useLocation } from "react-router-dom";

type QueryPreservingRedirectProps = {
  // The new static path. Kept a plain string (not a builder like `EntityIdRedirect`'s `to`)
  // because every call site today is a fixed target — the thing that varies is the query string,
  // which this component carries through on its own.
  to: string;
};

/**
 * Permanent client-side redirect for a normalised route whose caller relies on the query string
 * surviving the rename (e.g. old `/order-by-request?isV2=true&itemIds=...` -> new
 * `/orders/from-request?isV2=true&itemIds=...`). `EntityIdRedirect` rebuilds its target from a
 * `:id` path param and drops everything else; this instead keeps the path static and forwards
 * `location.search` verbatim, since the target route reads its state from query params, not from
 * the path.
 */
const QueryPreservingRedirect = ({ to }: QueryPreservingRedirectProps) => {
  const location = useLocation();
  return <Navigate to={{ pathname: to, search: location.search }} replace />;
};

export default QueryPreservingRedirect;
